import AuthLayoutImage from 'assets/images/landing.png';

const useStyles = theme => (  {
  root: {
    height: '100%',
  },
  imageWrapper: {
    backgroundImage: `url(${AuthLayoutImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    [theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  },
  formWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  formContent: {
    maxWidth: '450px',
    padding: theme.spacing(25),
    textAlign: 'center',
    '& label': {
      display: 'block',
    },
    '& form': {
      textAlign: 'left',
      marginTop: theme.spacing(20),
    },
    '& .MuiTextField-root': {
      width: '100%',
    },
    '& .MuiButton-contained': {
      width: '100%',
    },
  },
});

export default useStyles;
